import React from 'react'
import { useTranslation } from 'react-i18next'

import Layout from '~components/SecondaryLayout'
import S from '~components/seo'
import SubNav from '~components/SubNav'
import Farms from './components/Farms'
import HowTo from './components/HowTo'
import Hero from './components/Hero'

const Buy = () => {
  const { t } = useTranslation()

  const subnav = [
    {
      id: 1,
      link: '#how',
      title: t('howToBuy'),
    },
    {
      id: 2,
      link: '#farms',
      title: t('farmsBridges'),
    },
    {
      id: 2,
      link: '#stake',
      title: t('stake'),
    },
  ]

  return (
    <>
      <S title="Buy XCAD" />
      <Layout
        heroChildren={
          <>
            <SubNav data={subnav} />
            <Hero />
          </>
        }
      >
        <HowTo />
        <Farms />
      </Layout>
    </>
  )
}

export default Buy
